import TriggerReviewModal from './trigger';
import RatingReviewModal from './modal';

function install(Vue) {
  Vue.component('trigger-review-modal', TriggerReviewModal);
  Vue.component('rating-review-modal', RatingReviewModal)
}

export default { install };